import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Api from '@/util/Api'
import Graphql from '@/util/GraphQL'
import EventBus from '@/util/EventBus'
const { Cache: MemoryCache } = require('memory-cache')
import initLogrocket from '@/services/vendor/initLogrocket'
import initIntercom from '@/services/vendor/initIntercom'
import initSentry from '@/services/vendor/initSentry'
import initGtag from '@/services/vendor/initGtag'
import UserEventApiService from '@/services/api/UserEventApiService'

Vue.config.productionTip = false

Vue.prototype.$api = Api
Vue.prototype.$graphql = Graphql
Vue.prototype.$eventBus = EventBus
Vue.prototype.$apiCache = new MemoryCache()
Vue.prototype.$logUserEvent = UserEventApiService.log

window.$eventBus = EventBus

require('./initComponents') 
initLogrocket(store)
initIntercom(store)
initGtag(store)
initSentry()

window.$vueInstance = new Vue({
  name: 'MainJs',
  router,
  store,
  render: h => h(App)
}).$mount('#app')

